<template>
  <div>
    <!-- Footer -->
    <footer
      id="footer"
      class="footer divider parallax layer-overlay overlay-dark bg-image-100-size pt-20"
      data-bg-img="images/202208/Sarah44.jpg"
      data-parallax-ratio="0.7"
    >
      <div class="container pb-20 pt-0">
        <div class="row text-center">
          <div class="col-md-12 mb-20">
            <div class="widget dark mb-0">
              <div class="logo mt-10 mb-20">
                <img src="/images/movement-flow-white-theme.png" alt />
              </div>
            </div>
          </div>
          <div class="trustpilot-widget" data-locale="it-IT" data-template-id="5419b6a8b0d04a076446a9ad" data-businessunit-id="6246c253f732c01f037197c6" data-style-height="24px" data-style-width="100%" data-theme="light" data-min-review-count="10" data-style-alignment="center">
            <a href="https://it.trustpilot.com/review/sarahfitnessmovementflow.com" target="_blank" rel="noopener">Trustpilot</a>
          </div>
          <div class="col-md-12 mt-20 mb-20">
            <div class="widget light mb-0">
              <h5 class="text-black-444 mb-0">Seguimi sui social</h5>
              <div class="clearfix">
                <ul
                  class="styled-icons icon-light icon-bordered small square list-inline mt-10"
                >
                  <li>
                    <a
                      href="https://www.facebook.com/sarah.abdessalem"
                      target="_blank"
                    >
                      <i class="fa fa-facebook text-black-444"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/sarah_fitness_addicted/"
                      target="_blank"
                    >
                      <i class="fa fa-instagram text-black-444"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="widget dark mb-0">
              <i class="fa fa-money text-theme-colored mr-5"></i>
              <a class="text-black-444" href="#"><b>PIVA</b> 04457370163</a>
              <div class="terms-link-div mt-20">
                <div class="m-0 pl-10 pr-10">
                  <a class="text-black-444 btn btn-link" href="/privacy"
                    >Privacy</a
                  >
                </div>
                <div class="m-0 pl-10 pr-10">
                  <a class="text-black-444 btn btn-link" href="/terms"
                    >Termini e condizioni</a
                  >
                </div>
                <div class="m-0 pl-10 pr-10">
                  <a class="text-black-444 btn btn-link" href="/cookies"
                    >Cookie</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>      

      <div class="container-fluid copy-right p-10 bg-gray-sf-light">
        <div class="row text-center">
          <div class="col-md-12">
            <p class="font-11 text-dark m-0">
              Copyright &copy;{{ new Date().getFullYear() }} Sarah Fitness. All
              Rights Reserved
            </p>
          </div>
        </div>
      </div>
    </footer>

    <a class="scrollToTop" href="#">
      <i class="fa fa-angle-up"></i>
    </a>
  </div>
</template>

<style scoped>
#footer .logo img {
  max-height: 100px;
}

#footer .text-dark {
  color: #333333;
}

.terms-link-div {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;
}

#footer {
  background-repeat: repeat;
  /* background-position-y: 0px !important; */
}
</style>

<script>
export default {
  name: "Footer",
};
</script>
